<template>
  <div id="page-consulRequest" class="d-flex">
    <MainBarMenu />
    <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="page-consulRequest py-3">
        <template v-if="processing">
          <b-col cols="12" class="text-center">
            <div id="loader" />
          </b-col>
        </template>
        <template v-else>
          <div class="container-fluid">
            <p class="title-1 mb-0 ml-4">
              SOLICITUD PERMISO SINDICAL - {{ this.$route.params.id }}
            </p>
            <p class="title-2 mb-0 ml-4">
              Estado: <b>{{ licenseState }}</b>
            </p>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div
                  class="cont-consulRequest-text d-flex flex-column justify-content-around mt-0 mt-md-1"
                >
                  <!-- .cont-title -->
                  <form
                    action=""
                    class="form-consulRequest mt-2 mb-5 mb-md-5 d-flex flex-column flex-md-row align-items-center"
                  >
                    <div role="tablist" class="col-12">
                      <b-card no-body class="mb-1" style="width: 100%">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            class="button1"
                            block
                            v-b-toggle.accordion-1
                            variant="info"
                          >
                            Datos de aprobación
                            <span class="when-opened">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-up.svg"
                              />
                            </span>
                            <span class="when-closed">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-down.svg"
                              />
                            </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse
                          id="accordion-1"
                          visible
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body class="px-1">
                            <table
                              class="table table-bordered table-striped table-hover table-lg"
                            >
                              <thead>
                                <tr>
                                  <td align="left" width="100px">
                                    <p class="p3"><b>Colaborador</b></p>
                                  </td>
                                  <td align="center" width="180px">
                                    <p class="p3">
                                      Aprobado
                                      <img
                                        class="centerImg1"
                                        src="@/assets/images/icons/circle-check.svg"
                                      />
                                    </p>
                                  </td>
                                  <td align="center" width="180px">
                                    <p class="p3">
                                      Rechazado
                                      <img
                                        class="centerImg1"
                                        src="@/assets/images/icons/deny.svg"
                                      />
                                    </p>
                                  </td>
                                  <td align="center" width="150px">
                                    <p class="p3">
                                      <b>Aprobador</b>
                                    </p>
                                  </td>
                                </tr>
                              </thead>
                              <tbody
                                v-for="worker in this.colaboradores"
                                v-bind:key="worker?.core_employee?.sharp_id"
                              >
                                <tr>
                                  <td valign="top">
                                    <p class="p1">
                                      {{ worker?.core_employee?.name }}
                                    </p>
                                  </td>
                                  <td bgcolor="#E4EBDB">
                                    {{ worker?.approvalString }}
                                  </td>
                                  <td bgcolor="#F7DADA">
                                    {{ worker?.rejectedString }}
                                  </td>
                                  <td>
                                    <p class="p1">
                                      {{ worker?.approver?.name }}
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-card-body>
                        </b-collapse>

                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            class="button1"
                            block
                            v-b-toggle.accordion-2
                            variant="info"
                          >
                            Tiquetes
                            <span class="when-opened">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-up.svg"
                              />
                            </span>
                            <span class="when-closed">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-down.svg"
                              />
                            </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse
                          id="accordion-2"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body class="px-5">
                            <b-card-text>
                              <div v-show="this.statusTkts == false">
                                <div class="row">
                                  <div class="col-4">
                                    <p class="p1">
                                      Fechas del permiso solicitadas
                                    </p>
                                  </div>
                                  <div class="col-4">
                                    <p class="p1">Inicio</p>
                                    <b-form-datepicker
                                      :value="
                                        get_date_start_and_end.started_date
                                      "
                                      class="mb-2"
                                      :date-format-options="{
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric',
                                      }"
                                      placeholder="AAAA-DD-MM"
                                      required
                                      disabled
                                      readonly
                                    />
                                  </div>
                                  <div class="col-4">
                                    <p class="p1">Fin</p>
                                    <b-form-datepicker
                                      :value="get_date_start_and_end.end_date"
                                      class="mb-2"
                                      :date-format-options="{
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric',
                                      }"
                                      placeholder="AAAA-DD-MM"
                                      disabled
                                      required
                                      readonly
                                    />
                                  </div>
                                </div>
                                <div class="row pt-4">
                                  <div class="col-4">
                                    <p class="p1">Solicitud de tiquetes:</p>
                                  </div>
                                  <div
                                    class="col-3 custom-control custom-switch"
                                  >
                                    <p class="p1">
                                      No
                                      <label class="switch">
                                        <input
                                          type="checkbox"
                                          v-model="ticket"
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                      Si
                                    </p>
                                  </div>
                                  <div class="col-5" v-if="ticket">
                                    <p class="p1">
                                      <input
                                        type="radio"
                                        id="destino"
                                        v-model="type"
                                        value="Nacional"
                                      />
                                      Nacional -
                                      <input
                                        type="radio"
                                        id="destino"
                                        v-model="type"
                                        value="Internacional"
                                      />
                                      Internacional
                                    </p>
                                  </div>
                                </div>
                                <!-- toaster informativos -->
                                <div
                                  class="row"
                                  v-if="getterSetting.load === false"
                                >
                                  <div class="col-12 pt-3">
                                    <!-- toaster  -->
                                    <toaster-informative
                                      :type="'warning'"
                                      :hide-circle-to-icon="true"
                                      :message="message_of_toaster"
                                      :show="error_solicited && ticket"
                                    />

                                    <toaster-informative
                                      :message="message_of_toaster"
                                      :show="
                                        error_solicited === false && ticket
                                      "
                                    />
                                    <!-- end -->
                                  </div>
                                </div>
                                <!-- end -->
                                <div class="row pt-4">
                                  <div class="col-4">
                                    <p class="p1">Horario sugeridos:</p>
                                  </div>
                                  <div class="col-4">
                                    <p class="p1">Ida</p>
                                  </div>
                                  <div class="col-4">
                                    <p class="p1">Vuelta</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-4">
                                    <p class="mb-md-0"></p>
                                  </div>
                                  <div class="col-4 mb-md-5">
                                    <input
                                      type="text"
                                      v-model="horaIda"
                                      placeholder="00:00am - 00:00am"
                                      class="form-control"
                                      id=""
                                    />
                                  </div>
                                  <div class="col-4 mb-md-5">
                                    <input
                                      type="text"
                                      v-model="horaRegreso"
                                      placeholder="00:00pm - 00:0pm"
                                      class="form-control"
                                      id=""
                                    />
                                  </div>
                                </div>
                                <div
                                  class="row"
                                  v-if="this.user.core_role_id == 1"
                                >
                                  <div class="col-12">
                                    <p class="mb-md-0" align="center">
                                      <button
                                        v-if="
                                          check_if_you_can_request_a_ticket &&
                                          error_solicited === false &&
                                          ticket &&
                                          getterSetting.load === false
                                        "
                                        :disabled="getterSetting.load"
                                        type="button"
                                        class="button4"
                                        v-on:click="updateRequestTkts"
                                      >
                                        Solicitar tiquetes
                                      </button>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div v-show="this.statusTkts == true">
                                <div class="row">
                                  <b-table
                                    :items="filas"
                                    :fields="campos"
                                    hover
                                  >
                                    <template v-slot:cell(Tiquetes)="row">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          {{ listApproveTkt[row.item.id] }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-slot:cell(Acciones)="row">
                                      <div class="row">
                                        <div
                                          class="col-12 text-left"
                                          v-show="listFilesTkt[row.item.id]"
                                        >
                                          <a
                                            target="_blank"
                                            :href="
                                              serverPath +
                                              '/' +
                                              listFilesTkt[row.item.id]
                                            "
                                          >
                                            <p class="td4">
                                              <img
                                                class="img1"
                                                src="@/assets/images/icons/clip.svg"
                                              />
                                              Ver
                                            </p>
                                          </a>
                                        </div>
                                      </div>
                                    </template>
                                  </b-table>
                                </div>
                              </div>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <div class="row" v-if="conditionCancelLicense">
                        <div class="col-6 pt-5" align="center">
                          <button
                            type="button"
                            class="btn btn-block btn-red-1"
                            @click="cancelRequest()"
                          >
                            Cancelar Permiso
                          </button>
                        </div>
                        <div
                          class="col-6 pt-5"
                          align="center"
                          v-if="valid_button_accept_permission"
                        >
                          <button
                            type="button"
                            class="btn btn-block btn-darkgreen-1"
                            @click="validation()"
                          >
                            <img
                              class="img1"
                              src="@/assets/images/icons/saveWhite.svg"
                            />
                            Aceptar permiso
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <!-- Management by Business Partner-->
                  <template v-if="canWithCode('business-partner', 'relaciones-laborales')">
                    <!-- en caso de que exista errores del lado del servidor -->
                    <b-alert
                      variant="danger"
                      dismissible
                      fade
                      :show="Object.keys(errorsRetraction).length > 0"
                    >
                      <b-row>
                        <b-col>
                          <b
                            >Por favor, corrija el(los) siguiente(s)
                            error(es):</b
                          >
                          <ul>
                            <li
                              v-for="(
                                error, idxErrorsRetraction
                              ) in errorsRetraction"
                              :key="idxErrorsRetraction"
                            >
                              {{ error.join(", ") }}
                            </li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-alert>

                    <!-- mensaje si todo sale bien -->
                    <toaster-informative
                      type="green"
                      hide-circle-to-icon
                      message="Se ha realizado correctamente la retractación. ya puedes descargar la respectiva carta."
                      :show="showMessageRetract"
                    />

                    <div id="management-retraction" class="ml-4">
                      <b-tabs v-model="index_tabs_retraction">
                        <b-tab title="Trazabilidad" active>
                          <b-row class="pt-4">
                            <b-col cols="8">
                              <traceability
                                :createdAt="getLicense.created_at"
                                :name="getLicense.petitioner.name"
                                title="Trazabilidad del permiso sindical"
                                subTitle="Solicitud"
                              />
                            </b-col>
                            <b-col cols="4" class="text-center align-self-end">
                              <b-button-group>
                                <b-button
                                  variant="outline-info"
                                  class="retraction-btn-cancel mr-2"
                                  v-if="begin_retraction"
                                  @click.prevent="cancelRetraction"
                                >
                                  Cancelar
                                </b-button>
                                <b-button
                                  size="lg"
                                  class="retraction-btn"
                                  :class="begin_retraction ? 'ml-2' : null"
                                  @click.prevent="retraction"
                                >
                                  {{ textBtnRetraction }}
                                </b-button>
                              </b-button-group>
                            </b-col>
                          </b-row>
                          <br />
                          <p class="sub-title">
                            Información completa de gestión del permiso
                          </p>
                          <toaster-informative
                            hide-circle-to-icon
                            message="Selecciona la(s) persona(s) a la(s) cual(es) quieres hacerle retractación del permiso."
                            :show="begin_retraction"
                          />
                          <management
                            class="component-management"
                            :beginRetraction="begin_retraction"
                            @selected:collaborator="selectedCollaborator"
                          />
                        </b-tab>
                        <b-tab
                          :disabled="
                            retraction_selected_collaborator.length === 0
                          "
                          title="Retractación"
                        >
                          <b-row class="pt-4">
                            <b-col cols="8">
                              <traceability
                                :createdAt="getLicense.created_at"
                                :name="getLicense.petitioner.name"
                                title="Retractación  del permiso sindical"
                                subTitle="Información de solicitud"
                              />
                            </b-col>
                            <b-col cols="12" class="pt-4">
                              <traceability
                                :collaborators="
                                  retraction_selected_collaborator
                                "
                                subTitle="Información respuesta del permiso"
                                @change:canRetract="changeCanRetract"
                                @change:daysRetraction="changeDaysRetraction"
                              />
                            </b-col>
                            <b-col cols="12" class="pt-4 text-right">
                              <b-button
                                variant="outline-info"
                                class="retraction-btn"
                                size="lg"
                                :disabled="getProcessingRetraction"
                                v-if="begin_retraction && canSendRetract"
                                @click.prevent="showModalOfRetract"
                              >
                                Confirmar Retractación
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-tab>
                      </b-tabs>
                    </div>

                    <hr class="hr-form-ipt" v-if="isVisible" />
                    <!-- Retractación de rechazado a aprobado -->
                    <div v-if="isVisible">
                      <b-row class="">
                        <b-col cols="8">
                          <traceability
                            :createdAt="getLicense.created_at"
                            :name="getLicense.petitioner.name"
                            title="Retractación de rechazado a aprobado"
                            subTitle="Solicitud"
                          />
                        </b-col>
                        <b-col cols="4" class="text-center align-self-end">
                          <b-button-group>
                            <b-button
                              variant="outline-info"
                              class="retraction-btn-cancel mr-2"
                              v-if="begin_reject"
                              @click.prevent="cancelRetractionReject"
                            >
                              Cancelar retractación
                            </b-button>
                            <b-button
                              v-if="!begin_reject"
                              size="lg"
                              class="retraction-btn"
                              :class="begin_reject ? 'ml-2' : null"
                              @click.prevent="begin_reject = true"
                            >
                              {{ textBtnRetractionReject }}
                            </b-button>
                          </b-button-group>
                        </b-col>
                      </b-row>
                      <p class="sub-title mt-4">
                        Información completa de los permisos rechazados
                      </p>
                      <toaster-informative
                        hide-circle-to-icon
                        message="Selecciona la(s) persona(s) a la(s) cual(es) quieres hacerle retractación del permiso."
                        :show="true"
                      />
                      <ManagementReject
                        class="component-management"
                        :beginReject="begin_reject"
                        :isReload="isReload"
                        @selected:collaborator="selectedCollaboratorReject"
                        @changeVisible="isVisible = false"
                        @changeReload="isReload = false"
                      />
                      <div
                        v-if="
                          retraction_reject_selected_collaborator.length > 0
                        "
                      >
                        <b-row class="pt-4">
                          <b-col cols="8">
                            <traceability
                              :createdAt="getLicense.created_at"
                              :name="getLicense.petitioner.name"
                              title="Retractación  del permiso sindical"
                              subTitle="Información de solicitud"
                            />
                          </b-col>
                          <b-col cols="12" class="pt-4">
                            <TraceabilityReject
                              :collaborators="
                                retraction_reject_selected_collaborator
                              "
                              :dataAvailableTickets="dataAvailableTickets"
                              subTitle="Información respuesta del permiso"
                              @change:canRetract="changeCanRetractReject"
                              @change:daysRetraction="
                                changeDaysRetractionReject
                              "
                            />
                          </b-col>
                          <b-col cols="12" class="pt-4 text-right">
                            <b-button
                              variant="outline-info"
                              class="retraction-btn"
                              size="lg"
                              v-if="canSendRetractReject"
                              @click.prevent="showModalOfRetractReject"
                            >
                              Confirmar Retractación
                            </b-button>
                          </b-col>
                        </b-row>
                      </div>
                    </div>

                    <!-- modal de retractacion -->
                    <b-modal
                      ref="my-modal-validate"
                      centered
                      hide-backdrop
                      no-close-on-backdrop
                      footer-class="d-flex justify-content-center"
                    >
                      <div class="d-block text-center">
                        <img
                          :src="
                            require('@/assets/modules/permisos-sindicales/icons/modal/alert.svg')
                          "
                          alt="modal-alert"
                        />
                        <p>
                          <strong>
                            ¿Estás seguro de continuar con retractación del
                            permiso?
                          </strong>
                        </p>
                      </div>
                      <template #modal-footer="{ cancel }">
                        <button
                          class="button-success"
                          @click.prevent="confirmRetraction"
                        >
                          Sí, estoy seguro
                        </button>
                        <a
                          href="#"
                          style="color: black"
                          class="ml-3"
                          @click="cancel"
                        >
                          volver
                        </a>
                      </template>
                    </b-modal>
                    <!-- modal de retractacion rechazado -->
                    <b-modal
                      ref="my-modal-validate-reject"
                      centered
                      hide-backdrop
                      no-close-on-backdrop
                      footer-class="d-flex justify-content-center"
                    >
                      <div class="d-block text-center">
                        <img
                          :src="
                            require('@/assets/modules/permisos-sindicales/icons/modal/alert.svg')
                          "
                          alt="modal-alert"
                        />
                        <p>
                          <strong>
                            ¿Estás seguro de continuar con retractación del
                            permiso?
                          </strong>
                        </p>
                      </div>
                      <template #modal-footer="{ cancel }">
                        <button
                          class="button-success"
                          @click.prevent="confirmRetractionReject"
                        >
                          Sí, estoy seguro
                        </button>
                        <a
                          href="#"
                          style="color: black"
                          class="ml-3"
                          @click="cancel"
                        >
                          volver
                        </a>
                      </template>
                    </b-modal>

                    <!-- Modal error -->
                    <b-modal id="modal-fail" hide-footer centered>
                      <div
                        class="col-12 d-flex flex-column align-items-center modalsTables"
                      >
                        <img
                          class="centerImg1"
                          src="@/assets/images/icons/close.svg"
                          width="20%"
                        />
                        <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
                        <p class="pt-5">{{ error.message }}</p>
                        <button
                          class="mt-5 mb-5 col-6 btn btn-danger p-2"
                          style="font-size: 16px"
                          @click="$bvModal.hide('modal-fail')"
                        >
                          Entendido
                        </button>
                      </div>
                    </b-modal>
                    <!-- Modal Success -->
                    <b-modal id="modal-success" hide-footer centered>
                      <div class="col-12 d-flex flex-column align-items-center">
                        <img
                          class="centerImg1"
                          src="@/assets/images/icons/checkbox-circle-line.svg"
                        />
                        <h2 class="pt-5 font-weight-bold">¡Proceso exitoso!</h2>
                        <label
                          class="pb-2 table-value"
                          style="
                            color: #455a64;
                            margin-bottom: 16px;
                            text-align: center;
                            margin-top: 10px;
                          "
                          >Retractación realizada con éxito</label
                        >
                        <OkayModal @click="$bvModal.hide('modal-success')">
                          Entendido
                        </OkayModal>
                      </div>
                    </b-modal>
                  </template>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6 pt-3">
                <letter-template
                  class="pt-2"
                  :is-edit-retraction="
                    continue_retraction || show_letter_by_is_retraction
                  "
                  :object-edit-retraction="daysOfRetract"
                  :dataAvailableTickets="dataAvailableTickets"
                />
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
          </div>
        </template>
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
// import TemplateLetter from "../approvals/TemplateLetter.vue";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import OkayModal from "@/components/core/button/okay-modal.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import serverConfig from "./../../services/config";
import { saveReverseRetraction } from "@/services/modules/permisos-sindicales/v2/licenses/service.js";
export default {
  name: "ConsulRequest",
  components: {
    MainBarMenu,
    OkayModal,
    // TemplateLetter,
    HeadingUser,
    toasterInformative: () =>
      import("@/components/common/toasters/Informative.vue"),
    letterTemplate: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Letters/Letter.vue"
      ),
    Management: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Management/Management.vue"
      ),
    ManagementReject: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Management/ManagementReject.vue"
      ),
    Traceability: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Traceability/Traceability.vue"
      ),
    TraceabilityReject: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/TraceabilityReject/TraceabilityReject.vue"
      ),
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      msjModal: "",
      flagPath: 0,
      keyComponent: 0,
      statusTkts: false,
      img1: "circle-clock.svg",
      img2: "circle-clock.svg",
      comments: [],
      comentario: "",
      ticket: false,
      type: "Nacional",
      horaIda: "",
      horaRegreso: "",
      fechaIni: "",
      tks: "",
      contPos: 0,
      addTks: false,
      approvals: [],
      selectedPersons: [],
      dates: [],
      datesOpen: [
        {
          start: null,
          end: null,
        },
      ],
      // listApproveTkt: [],
      // listFilesTkt: [],
      campos: [
        { key: "Colaboradores", class: "text-left" },
        { key: "Origen", class: "text-center" },
        { key: "Tiquetes", class: "text-center" },
        { key: "Acciones", class: "text-center" },
      ],
      filas: [],
      monthNames: [
        "cero",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      nationalDays: 0,
      internationalDays: 0,
      message_of_toaster: "",
      error_solicited: false,
      processing: true,
      begin_retraction: false,
      begin_reject: false,
      retraction_selected_collaborator: [],
      retraction_reject_selected_collaborator: [],
      continue_retraction: false,
      index_tabs_retraction: 1,
      canSendRetract: false,
      canSendRetractReject: false,
      daysOfRetract: {},
      showMessageRetract: false,
      errorsRetraction: {},
      dataAvailableTickets: null,
      isVisible: true,
      daysOfRetractReject: null,
      isReload: false,
    };
  },
  async beforeMount() {
    /*this.actGetSettings().then(() =>{
      this.nationalDays = this.settings.data.national_tickets_days;
      this.internationalDays = this.settings.data.international_tickets_days;
    }); */
    this.processing = true;
    const license_id = this.$route.params.id;
    await this.actGetRequest(license_id)
      .then(() => {
        // this.loadRows();
        this.dataAvailableTickets = {
          society_id: this.request.data.license.petitioner_society.id,
          startDate: this.request.data.license.startDate,
        };
        this.horaIda =
          this.request.data.license.license_employees[0].ticket.departureTime;
        this.horaRegreso =
          this.request.data.license.license_employees[0].ticket.returnTime;
        this.comments = this.request.data.license.lic_comments;
        this.statusTkts = this.request.data.license.tickets;
        this.fechaIni = this.request.data.license.startDate;
        this.getTraceabilityAction({ id: license_id });
        // this.loadInfoDates();
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: " + response;
      })
      .finally(() => (this.processing = false));
  },
  computed: {
    ...mapGetters("permisosSindicalesV2License", ["getProcessingRetraction"]),
    show_letter_by_is_retraction() {
      const me = this;
      let status = false;
      me.colaboradores.some((item) => {
        const record = item?.days?.some((x) => x?.status === "retraction");
        if (record) {
          status = true;
          return true;
        }
        return false;
      });
      return status;
    },
    id() {
      return Number(this.$route.params.id || 0);
    },
    textBtnRetraction() {
      return this.begin_retraction
        ? "Continuar Retractación"
        : "Iniciar Retractación";
    },
    textBtnRetractionReject() {
      return this.begin_reject
        ? "Continuar Retractación"
        : "Iniciar Retractación";
    },
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["request", "loading", "settings"]),
    listFilesTkt() {
      return this.colaboradores.map(({ ticket }) => ticket.image || null);
    },
    listApproveTkt() {
      const states = {
        approved: "Aprobado",
        pending: "Pendiente",
        not_applicable: "No aplica",
      };
      return this.colaboradores.map(({ ticket }) =>
        ticket.status in states ? states[ticket.status] : "Rechazado"
      );
    },
    colaboradores() {
      return this.request.data.license.license_employees
        ? this.loadInfoDates(this.request.data.license.license_employees)
        : [];
    },
    validaStateLicenseDays() {
      let cont = 0;
      this.request.data.license.license_employees.forEach((worker) => {
        worker.days.forEach((day) => {
          if (day.status === "pending") {
            cont += 1;
          }
        });
      });
      return cont;
    },
    conditionCancelLicense() {
      return !!(
        this.canWithCode("solicitante-sindical") && this.licenseIfPending
      );
    },
    licenseIfPending() {
      return this.licenseState === "PENDIENTE";
    },
    /*
      estado de la solicitud
     */
    licenseState() {
      const { status } = this.getLicense;
      const values = {
        pending: "PENDIENTE",
        closed: "CERRADA",
      };
      if (status in values) return values[status];
      return "REVISION";
    },
    getLicense() {
      return this.request.data ? this.request.data.license : {};
    },
    /**
     * Validar el boton de acceptar permiso
     **/
    valid_button_accept_permission() {
      return (
        (this.validaStateLicenseDays === 0 && this.error_solicited === false) ||
        (this.validaStateLicenseDays === 0 && this.ticket === false)
      );
    },
    /**
     * Obteniendo las opciones de los tiquetes del Store
     **/
    ...mapGetters("modSettings", ["getterSetting"]),
    /**
     * obtiene numero de tiquetes por dia configuraciones de fechas
     **/
    get_date_ticket_national_and_international() {
      return {
        Nacional: this.getterSetting.national,
        Internacional: this.getterSetting.international,
      };
    },
    /**
     * obtiene la fecha inicial y final
     **/
    get_date_start_and_end() {
      const { data } = this.request;
      if (data) {
        const { license } = data;
        if (license) {
          return {
            started_date: license.startDate,
            end_date: license.endDate,
          };
        }
      }
      return {
        started_date: null,
        end_date: null,
      };
    },
    /**
     * validar si puede solicitar tiquetes
     **/
    check_if_you_can_request_a_ticket() {
      const { data } = this.request;
      if (data) {
        const { license } = data;
        if (license) {
          return license.status === "pending" && license.tickets === 0;
        }
      }
      return false;
    },
    /**
     * lista de tipos de tiquetes
     **/
    list_of_ticket_type() {
      return {
        Nacional: {
          message:
            "Recuerda que las solicitudes con tiquetes Nacionales deben ser" +
            " solicitadas con " +
            this.getterSetting.national +
            " días de anterioridad del permiso sindical, de no ser" +
            " así no podrás solicitar el permiso sindical.",
          warning:
            "Estás solicitando un tiquete nacional con menos\n" +
            this.getterSetting.national +
            " días de anticipación, tu solicitud no podrá ser gestionada.",
        },
        Internacional: {
          message:
            "Recuerda que las solicitudes con tiquetes Internacionales deben ser solicitados con " +
            this.getterSetting.international +
            " días de anterioridad y máximo 6 meses antes del permiso sindical, de no ser así no " +
            "podrás solicitar el permiso sindical.",
          warning:
            "Estás solicitando un tiquete internacional con menos\n" +
            this.getterSetting.international +
            " días de anticipación, tu solicitud no podrá ser gestionada.",
        },
      };
    },
  },
  watch: {
    /**
     * cuando cambia el tiquete cambia el mensaje
     **/
    async ticket() {
      if (this.ticket) {
        await this.getSettingOrCustomize(this.type);
      }
      this.valid_tickets();
    },
    /**
     * cuando cambia el tipo de tiquete cambia el mensaje
     **/
    type() {
      this.valid_tickets();
    },
  },
  methods: {
    ...mapActions("modRequest", [
      "actGetRequest",
      "actSaveComments",
      //"actUpdateStateRequest",
      "actUpdateRequestTkts",
      //"actRequestReview",
      "actGetSettings",
      "actSetRequestStatus",
    ]),
    ...mapActions("modSettings", ["getSettingOrCustomize"]),
    ...mapActions("permisosSindicalesV2License", [
      "postRetractionAction",
      "getTraceabilityAction",
      "getLicenseAction",
    ]),
    async confirmRetraction() {
      this.$refs["my-modal-validate"].hide();
      await this.postRetractionAction({
        id: this.id,
        data: this.daysOfRetract,
      })
        .then(() => {
          this.showMessageRetract = true;
          this.begin_retraction = false;
          this.retraction_selected_collaborator = [];
          this.continue_retraction = false;
          this.index_tabs_retraction = 1;
          this.getTraceabilityAction({ id: this.id });
          this.getLicenseAction({ id: this.id });
          this.actGetRequest(this.id);
        })
        .catch(
          ({
            response: {
              data: { message },
            },
          }) => (this.errorsRetraction = message)
        );
    },
    async confirmRetractionReject() {
      const me = this;
      const employees = [];
      me.$refs["my-modal-validate-reject"].hide();
      me.daysOfRetractReject.license.forEach((item) => {
        const record = employees.find((x) => x.lic_employee_id == item.id);

        if (record) {
          record.day_ids.push(item.day);
        } else {
          employees.push({
            lic_employee_id: item.id,
            day_ids: [item.day],
            has_ticket: item.has_ticket,
          });
        }
      });

      try {
        await saveReverseRetraction(me.id, {
          employees,
          motive: me.daysOfRetractReject.motive,
        });

        me.getTraceabilityAction({ id: me.id });
        me.getLicenseAction({ id: me.id });
        me.actGetRequest(me.id);
        me.begin_reject = false;
        me.retraction_reject_selected_collaborator = [];
        me.isReload = true;
        me.$bvModal.hide("modal-success");
      } catch (error) {
        me.$bvModal.show("modal-fail");
      }
    },
    showModalOfRetract() {
      this.$refs["my-modal-validate"].show();
    },
    showModalOfRetractReject() {
      this.$refs["my-modal-validate-reject"].show();
    },
    changeDaysRetraction({ days, can }) {
      this.canSendRetract = can;
      this.daysOfRetract = days;
    },
    changeDaysRetractionReject({ days, can }) {
      this.canSendRetractReject = can;
      this.daysOfRetractReject = days;
    },
    changeCanRetract({ can }) {
      this.canSendRetract = can;
    },
    changeCanRetractReject({ can }) {
      this.canSendRetractReject = can;
    },
    cancelRetraction() {
      this.begin_retraction = false;
      this.continue_retraction = false;
      this.index_tabs_retraction = 1;
    },
    cancelRetractionReject() {
      this.begin_reject = false;
      this.retraction_reject_selected_collaborator = [];
    },
    selectedCollaborator(items) {
      this.retraction_selected_collaborator = items;
    },
    selectedCollaboratorReject(items) {
      this.retraction_reject_selected_collaborator = items.map((item) => {
        return {
          ...item,
          has_ticket: false,
        };
      });
    },
    continueRetraction() {
      this.continue_retraction = true;
      this.index_tabs_retraction = 2;
    },
    retraction() {
      if (
        this.begin_retraction &&
        this.retraction_selected_collaborator.length > 0
      ) {
        this.continueRetraction();
      } else {
        this.begin_retraction = true;
      }
    },
    /***
     * valida la diferencia de los tiquetes
     **/
    valid_tickets() {
      if (this.getterSetting.many_key) {
        if (this.list_of_ticket_type[this.type]) {
          if (this.get_date_ticket_national_and_international[this.type]) {
            if (
              this.get_date_difference(
                this.get_date_start_and_end.started_date,
                this.get_today
              ) <= this.get_date_ticket_national_and_international[this.type]
            ) {
              this.error_solicited = true;
              return this.valid_exist_ticket_national_or_international();
            }
          }
        }
      }
      this.error_solicited = false;
      return this.valid_exist_ticket_national_or_international();
    },
    /***
     * valida si existe y retorna el mensaje de ser necesario en los toaster Nacional e Internacional
     **/
    valid_exist_ticket_national_or_international() {
      if (this.ticket) {
        this.set_message(this.type);
      }
    },
    /***
     * Se asigna el memsaje dependdiendo de la llave seleccionada
     **/
    set_message(key = "No") {
      if (this.error_solicited) {
        if (this.list_of_ticket_type[key]) {
          return (this.message_of_toaster =
            this.list_of_ticket_type[key].warning);
        }
      }
      if (this.list_of_ticket_type[key]) {
        return (this.message_of_toaster =
          this.list_of_ticket_type[key].message);
      }
    },
    updateComment() {
      if (this.comentario) {
        let data = "";
        data = {
          license_id: this.$route.params.id,
          core_employee_id: this.user.id,
          text: this.comentario,
        };
        //alert(JSON.stringify(data));
        this.actSaveComments(data)
          .then(() => {
            this.success.flag = true;
            this.success.class = "is-valid";
            this.success.message = "El comentario quedó guardado";

            this.actGetRequest(this.$route.params.id)
              .then(() => {
                this.comments = this.request.data.license.lic_comments;
              })
              .catch(() => {
                this.error.flag = true;
                this.error.class = "is-invalid";
                this.error.message =
                  "Ocurrio un error al guardar por favor actualizar la pagina.";
              });
            this.comentario = "";
          })
          .catch(() => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message =
              "Ocurrio un error al guardar por favor actualizar la pagina.";
          });
      } else {
        this.showModal("Debe ingresar un comentario", 0);
      }
    },
    updateState(status) {
      //alert(status);
      let data = [];
      data[0] = this.$route.params.id;
      data[1] = { status: status };
      this.actSetRequestStatus(data)
        .then(() => {
          this.showModal("La solicitud quedó actualizada con exito.", 1);
        })
        .catch(() => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "Ocurrio un error al guardar por favor actualizar la pagina.";
        });
    },
    updateRequestTkts() {
      if (this.check_if_you_can_request_a_ticket) {
        if ((this.type, this.horaIda, this.horaRegreso, this.ticket)) {
          let data = [];
          data[0] = this.$route.params.id;
          data[1] = {
            tickets: this.ticket,
            type: this.type,
            departureTime: this.horaIda,
            returnTime: this.horaRegreso,
          };
          //alert(JSON.stringify(data));
          this.actUpdateRequestTkts(data)
            .then(() => {
              this.success.flag = true;
              this.success.class = "is-valid";
              this.showModal("¡La solicitud quedó actualizada con exito!", 1);
            })
            .catch(() => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "Ocurrio un error al guardar por favor actualizar la pagina.";
            });
        } else {
          this.showModal(
            "Debe diligenciar todos los cambios: (Tiquetes - Si, Hora Ida, Hora Regreso)",
            0
          );
        }
      }
    },

    loadInfoDates(colaboradores) {
      let monthsA = [];
      let monthsR = [];
      for (let i = 0; i < colaboradores.length; i++) {
        monthsA = [];
        monthsR = [];
        colaboradores[i]["approvalString"] = "";
        colaboradores[i]["rejectedString"] = "";
        for (let j = 0; j < colaboradores[i].days.length; j++) {
          if (colaboradores[i].days[j].status === "approved") {
            colaboradores[i]["approvalString"] +=
              colaboradores[i].days[j].day.substring(8, 10) + ", ";
            monthsA.push(
              this.monthNames[
                parseInt(colaboradores[i].days[j].day.substring(5, 7))
              ]
            );
          }
          if (colaboradores[i].days[j].status === "rejected") {
            colaboradores[i]["rejectedString"] +=
              colaboradores[i].days[j].day.substring(8, 10) + ", ";
            monthsR.push(
              this.monthNames[
                parseInt(colaboradores[i].days[j].day.substring(5, 7))
              ]
            );
          }
        }
        // Generamos los meses para imprimir 1 sola vez
        if (colaboradores[i]["approvalString"]) {
          let months1 = this.uniq(monthsA);
          months1.forEach((element) => {
            colaboradores[i]["approvalString"] += " " + element;
          });
        }
        if (colaboradores[i]["rejectedString"]) {
          let months2 = this.uniq(monthsR);
          months2.forEach((element) => {
            colaboradores[i]["rejectedString"] += " " + element;
          });
        }
      }
      return colaboradores;
    },
    uniq(a) {
      var seen = {};
      var out = [];
      var len = a.length;
      var j = 0;
      for (var i = 0; i < len; i++) {
        var item = a[i];
        if (seen[item] !== 1) {
          seen[item] = 1;
          out[j++] = item;
        }
      }
      return out;
    },
    validation() {
      this.$bvModal
        .msgBoxConfirm(
          "El estado de la solicitud cambiará a cerrado y no podrá volver a modificarse; ¿Desea continuar?",
          {
            title: "Atención al mensaje:",
            size: "lg",
            buttonSize: "lg",
            okVariant: "danger",
            okTitle: "CONTINUAR",
            cancelTitle: "CANCELAR",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.updateState("closed");
          }
        })
        .catch(() => {
          // console.log(err);
        });
    },
    validationRequest() {
      this.$bvModal
        .msgBoxConfirm(
          "Se enviara una notificación a todos los aprobadores de esta Solicitud. ¿Desea continuar?",
          {
            title: "Atención al mensaje:",
            size: "lg",
            buttonSize: "lg",
            okVariant: "danger",
            okTitle: "CONTINUAR",
            cancelTitle: "CANCELAR",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.updateState("review");
          }
        })
        .catch(() => {
          // console.log(err);
        });
    },
    cancelRequest() {
      if (!this.licenseIfPending) return;
      this.$bvModal
        .msgBoxConfirm("Se cancelará esta Solicitud. ¿Desea continuar?", {
          title: "Atención al mensaje:",
          size: "lg",
          buttonSize: "lg",
          okVariant: "danger",
          okTitle: "CONTINUAR",
          cancelTitle: "CANCELAR",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.updateState("cancelled");
          }
        })
        .catch(() => {
          // console.log(err);
        });
    },
    formatDateShow(date) {
      var d = new Date(date);
      var datestring =
        d.getDate() +
        " " +
        this.monthNames[d.getMonth() + 1] +
        " " +
        d.getFullYear();
      return datestring;
    },
    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");
.button-success {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #269887;
  border: 1px solid #269887;
  color: #ffffff;
  border-radius: 27px;
  box-shadow: none;
}
.button-success:hover {
  background: #269887de;
}
#management-retraction {
  .tabs .nav-link:hover {
    border-bottom: 1px solid transparent !important;
  }

  .tabs .nav-link.active {
    background: #1c6776 !important;
    border-radius: 20px;
    color: #fff !important;
    border-bottom: none !important;
  }

  .tabs .nav-link {
    line-height: 1.2;
  }

  .tabs .nav-tabs {
    border: 1px solid #c9caff !important;
    border-radius: 48px;
    padding: 3px;
    display: inline-flex;
    font-weight: bold;
  }

  .component-management {
    border: 1px solid rgba(28, 58, 78, 1);
    padding: 10px;
    border-radius: 8px;
  }
}

.sub-title {
  color: rgba(28, 58, 78, 1);
  font-weight: 600;
  font-size: 16px;
}
.retraction-btn {
  color: #ffffff !important;
  border-radius: 20px !important;
  background: #1c6776 !important;
}

.retraction-btn-cancel {
  color: #1c3a4e !important;
  border-radius: 20px !important;
  background: #ffffff !important;
  border-color: #1c3a4e !important;
}
.page-consulRequest {
  .title-1 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }
  .cont-consulRequest-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-consulRequest {
      .form-group-req {
        label {
          position: absolute;
          color: #454545;
          font-size: 12px;
          background-color: #e9ecee;
          padding: 4px;
          top: -16px;
          left: 10px;
        }
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
      .button1 {
        font-family: "Open Sans", serif;
        background: #e9ecee;
        color: #1c3a4e;
        font-weight: bold;
        //border-radius: 50px;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;
        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }
      .button2 {
        background: #1c3a4e;
        color: #ffffff;
        border-radius: 50px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#cddce6, 5);
        }
      }
      .button4 {
        background: #99a6af;
        color: #ffffff;
        border-radius: 8px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#99a6af, 5);
        }
      }
      tr {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #454545;
        padding-left: 5%;
      }
      .p1 {
        font-family: "Open Sans";
        font-style: normal;
        font-size: 11px;
        line-height: 22px;
        color: #888888;
        display: block;
        padding-left: 15px;
        text-indent: -15px;
      }
      .p2 {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #454545;
        padding-left: 5%;
      }
      .p3 {
        color: #1c3a4e;
        height: 32px;
        font-size: 16px;
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
      }
    }
  }
  .td1 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #1c3a4e;
    border-color: #1c3a4e;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 530px;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .img1 {
    width: 18px;
    height: 18px;
    //position: absolute;
    left: 100%;
    top: 100%;
    //margin-left: -9px;
    //margin-top: 9px;
    float: center;
    //clear: center;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    //position: absolute;
    //left: 50%;
    top: 100%;
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: center;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #779b49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
